import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Rotas} from "src/app/core/rotas";
import {BaseService} from "../base/base.service";
import {ConsultaBanco} from "../../core/consulta-banco";

@Injectable({
    providedIn: "root",
})
export class ConsultaBancoService extends BaseService<ConsultaBanco> {
    constructor(http: HttpClient) {
        super(http, Rotas.CONSULTA_BANCO);
    }

    getCombo(tipoConsulta) {
        return this.http.get(`${this.rota}combo/${tipoConsulta}`);
    }

    getByIdRim(idRim) {
        return this.http.get(`${this.rota}lista?idRim=${idRim}`);
    }

    carregarTabela(idConsulta, idRim) {
        return this.http.get(`${this.rota}carregarTabela?idConsulta=${idConsulta}&idRim=${idRim}`);
    }
}
